module.exports = __webpack_public_path__ + "media/images/features/7/main-2-7b47286202986121a1b772b902315984.jpg";